import { type, textColor, surface } from '@datahub/design-system'
import { MAX_UPLOAD_MB, ACCEPTED_UPLOAD_LABEL } from '../lib/uploads'

interface RequirementsPanelProps {
  companyName: string
  periodLabel: string
}

/**
 * The "File Format Requirements" callout from the Figma "Portfolio Reporting" frame
 * (node 4352:18988): a 16px heading over inline label-and-value pairs, closed by an
 * italic example line in the faint grey.
 */
export function RequirementsPanel({ companyName, periodLabel }: RequirementsPanelProps) {
  const example = `${periodLabel.replace(/\s+/g, '-')}-Income statement-${companyName}.pdf`

  const rules: [string, string][] = [
    ['Accepted formats:', ACCEPTED_UPLOAD_LABEL],
    ['Maximum file size:', `${MAX_UPLOAD_MB}MB per document`],
    ['File naming:', '[Reporting Period] - [Year] - [Document Type] - [Company Name]'],
  ]

  return (
    <div
      style={{
        backgroundColor: surface.callout,
        border: `0.5px solid ${surface.border}`,
        padding: 20,
      }}
    >
      <div className="flex flex-col" style={{ gap: 12 }}>
        <h2 className="font-jakarta" style={{ ...type.panelHeading, fontWeight: 600, color: textColor.primary }}>
          File Format Requirements
        </h2>

        <div className="flex flex-wrap" style={{ columnGap: 32, rowGap: 8 }}>
          {rules.map(([label, value]) => (
            <span key={label} className="font-jakarta" style={{ ...type.body, color: textColor.primary }}>
              <strong style={{ fontWeight: 700 }}>{label}</strong>{' '}
              <span style={{ color: textColor.muted }}>{value}</span>
            </span>
          ))}
        </div>

        <span className="font-jakarta" style={{ ...type.body, color: textColor.faint }}>
          <em>Example:</em> {example}
        </span>
      </div>
    </div>
  )
}
